import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import NotesIcon from "@mui/icons-material/Notes";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeIcon from "@mui/icons-material/Home";
import useFetching from "../services/careerService";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminStatus } from "../hooks/useAdminStatus";

const Sidebar = () => {
  const { instance } = useMsal();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const { getAccountInfo } = useFetching();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useAdminStatus();

  function handleLogout() {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }

  function handleHomeScreen() {
    navigate("/");
  }

  function handleAdminPage() {
    navigate("/admin");
  }

  useEffect(() => {
    const account = instance.getAllAccounts()[0];
    if (account) {
      setName(account.name);
      setEmail(account.username);
    }
  }, [instance]);

  return (
    <div className="sidebar container-side">
      <div className="sidebar-header">
        <h1 className="career-heading">Karrierekonto</h1>
      </div>
      <div className="container-column">
        <nav className="side-nav">
          <div className="account-details">
            <PersonOutlineIcon
              style={{ marginRight: "16px" }}
              fontSize="large"
            />
            <div className="account-text">{name}</div>
          </div>
          {location.pathname !== "/" && (
            <button className="button-sidebar" onClick={handleHomeScreen}>
              <HomeIcon />
              <span>Übersicht</span>
            </button>
          )}
          {location.pathname !== "/admin" && isAdmin !== null && isAdmin && (
            <button className="button-sidebar" onClick={handleAdminPage}>
              <AdminPanelSettingsIcon />
              <span>Admin Page</span>
            </button>
          )}
          <button className="button-sidebar" onClick={handleLogout}>
            <LogoutIcon />
            <span>Logout</span>
          </button>
          {/*<button className="button-sidebar">
            <QuestionMarkIcon />
            <span>Hilfe</span>
          </button>
          <button className="button-sidebar">
            <NotesIcon />
            <span>Impressum</span>
          </button>*/}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
